
var vskoSpinner = angular.module('vskoSpinner', []);
vskoSpinner.directive('vskoSpinner', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-spinner.html'),
    replace: false,
    transclude: true,
    scope: {
       big: '=',
       centered: '='
    },
    link: function ($scope, element, attrs, ctrl, transclude) {
      'use strict';
      $scope.getStyle = function () {
          var style = "";
          if($scope.hasContent) {
             style = $scope.centered ? 'bc-spinner-message-holder-centered' : 'bc-spinner-message-holder';
          } 
          return style;
      }
      transclude(function(clone){
        if(clone.length){
          $scope.hasContent = true;
        }
      });
    }
  }
}]);
  